import { motion } from "framer-motion";

/**
 * Line-by-line masked reveal.
 * Pass an array of strings for `lines`. Each line rises from a masked container.
 * `mode="scroll"` (default) uses whileInView; `mode="load"` fires on mount.
 */
export default function MaskedReveal({
  lines = [],
  as: Tag = "h1",
  className = "",
  delay = 0.05,
  lineClass = "",
  duration = 0.9,
  once = true,
  onDark = true,
  mode = "scroll",
}) {
  return (
    <Tag className={className}>
      {lines.map((line, i) => {
        const anim = { y: "0%" };
        const commonProps = {
          className: "inline-block",
          initial: { y: "110%" },
          transition: {
            duration,
            ease: [0.19, 1, 0.22, 1],
            delay: delay + i * 0.08,
          },
        };
        return (
          <span key={i} className={`reveal-mask block ${lineClass}`}>
            {mode === "load" ? (
              <motion.span {...commonProps} animate={anim}>
                {line}
              </motion.span>
            ) : (
              <motion.span
                {...commonProps}
                whileInView={anim}
                viewport={{ once }}
              >
                {line}
              </motion.span>
            )}
          </span>
        );
      })}
    </Tag>
  );
}
